export default "__VITE_ASSET__CyzBdS97__"